import { ApiProperty } from "@nestjs/swagger";

export class MaterialPreperationRequest{
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderItemId:number;
    @ApiProperty()
    itemId:number;
    @ApiProperty()
    itemBarcode:string;
    @ApiProperty()
    preparedQuantity:number;
    @ApiProperty()
    consumedQuantity:number;
    @ApiProperty()
    stockinQuantity:number;
    @ApiProperty()
    stockId:number;
    @ApiProperty()
    poNumber:string;
    @ApiProperty()
    soItemName:string;
    @ApiProperty()
    itemName:string;
    @ApiProperty()
    createdUser?:string;
    @ApiProperty()
    soItemBarcode?:string;
    @ApiProperty()
    brandId?:number;
    @ApiProperty()
    variantId?:number;
    @ApiProperty()
    endCustomerId?:number;
    @ApiProperty()
    packStyleId?:number;
    @ApiProperty()
    subCategoryId?:number;
}